
import httpClient from "../Core/http";

class SparepartsAPi {
  getSpareparts(params: any): Promise<any> {
    let url = "Spareparts/machine";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }

  getSparepartsBySvcID(params: any, signal: any): Promise<any> {
    let url = "Spareparts/bySvcCallID";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getUsedSpareparts(params: any, signal: any): Promise<any> {
    let url = "Spareparts/used";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const SparepartsApi = new SparepartsAPi();
